import * as AlertsActionsContent from './alerts-actions-content';
import AlertsActionsNav from './alerts-actions-nav';
import Config from './alerts-actions.router';
import options from './alerts-actions.component';

require('./alerts-actions.png'); // eslint-disable-line

const Component = {
    selector: 'dtAlertsActions',
    options
};

export {
    Component,
    Config,
    AlertsActionsNav,
    AlertsActionsContent
};



// WEBPACK FOOTER //
// ./app/components/alerts-actions/index.js